<template lang="pug">
  .explore-detail
    .container-fluid.h-100
      .row.h-100.p-0.m-0.warning
        .warning-text 請將手機橫置<br>以獲得最佳觀賞體驗
      .row.h-100
        .col.left.h-100
          .deco-left.animate__animated.animate__slideInDown
          // .explore-icons
            img.icon(v-if="media.pano" src="@/assets/images/explore-icon-720.png")
            img.icon(v-if="media.vr" src="@/assets/images/explore-icon-360.png")
            img.icon(v-if="media.video" src="@/assets/images/explore-icon-play.png")
        .col.right.h-100
          font-awesome-icon.explore-close-icon(:icon="'times'" size="3x"  :style=`{ color: 'white'}` @click="closeDetail")
          .deco-right.animate__animated.animate__slideInUp
        #pano-viewer.col.main(v-if="mediaType == 'pano'")
          span.center Loading...
        iframe#vr-viewer.col.main(v-if="mediaType == 'vr'" :src="media.vr")
        iframe#video-viewer.col.main(v-if="mediaType == 'video'" src="https://www.youtube.com/embed/PAcQ8Ned_xc" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen)

</template>

<script>
import { Viewer } from "photo-sphere-viewer";
import "photo-sphere-viewer/dist/photo-sphere-viewer.css";

export default {
  name: "ExploreDetail",

  data() {
    return {
      viewer: null
    };
  },
  props: {
    media: {
      type: Object,
      default: function() {
        return {
          pano: null,
          vr: null,
          video: null,
          panoDefault: null
        };
      }
    },
    mediaType: {
      type: String,
      default: "pano"
    }
  },
  methods: {
    closeDetail() {
      this.$parent.showDetail = false;
    },
    setPanoImg(imgName, panoDefault) {
        this.viewer = new Viewer({
          container: document.querySelector("#pano-viewer"),
          panorama: require(`../assets/images/${imgName}`),
          defaultLong: panoDefault.defaultLong ||2 * Math.PI * (-10 / 360),
          defaultLat: panoDefault.defaultLat || (Math.PI / 2) * (55 / 180),
          defaultZoomLvl: panoDefault.defaultZoomLvl || 30,
          sphereCorrection: panoDefault.sphereCorrection || null,
          navbar:[
            'autorotate',
            'zoom'
          ]
        });
    }
  },
  mounted() {
    console.log(this.media)
    if (this.mediaType == "pano") {
      setTimeout(()=>{
        this.setPanoImg(this.media.pano, this.media.panoDefault);
      },800)
    }
    document.querySelector('.texture').classList.remove('minHeight')
  },
  beforeDestroy(){
    document.querySelector('.texture').classList.add('minHeight')
  }
};
</script>

<style scoped lang="sass">
// background: url("../assets/images/triangle-right.svg")
.explore, .texture
  min-height: unset !important

.explore-detail
  width: 100vw
  // height: 100vh
  height: 100%
  background-color: black
  position: absolute
  top: 0
  left: 0
  overflow: hidden
  .warning
    display: none
    position: fixed
    top: 0
    left: 0
    width: 100%
    height: 100%
    background-color: rgba(0, 0, 0, 0.85)
    z-index: 667
    .warning-text
      position: absolute
      left: 50%
      top: 50%
      transform: translate3d(-50%, -50%, 0)
      color: white
      text-align: center
      font-weight: bold
      font-size: 8vw


  @keyframes moveRight
    0%,30%
      transform: translate(-100px)
    100%
      transform: translate(0px)
  @keyframes moveLeft
    0%,30%
      transform: translate(100px)
    100%
      transform: translate(0px)
      

  span.center
    position: absolute
    left: 50%
    top: 50%
    transform: translate(-50%,-50%)
    opacity: 0.8
  .main
    position: absolute
    left: 7.5vw
    top: 5vh
    width: 80vw
    height: 90vh
    // padding: 5px
    background-color: #eee
      // background-color: #000
    
    
    // background-color: black
    &:before
      content: ''
      position: absolute
      height: 102%
      width: 25vw
      pointer-events: none
      background: url("../assets/images/curve-left.svg")
      animation: moveRight 1.2s both
      left: -5px
      top: -2px
      z-index: 6
      background-repeat: no-repeat
    &:after
      content: ''
      position: absolute
      pointer-events: none
      height: 102%
      width: 25vw
      background: url("../assets/images/curve-right.svg")
      animation: moveLeft 1.2s both
      right: -1px
      top: -2px
      z-index: 6
      background-repeat: no-repeat
      background-position: 100%
  .left
    position: absolute
    left: 0
    top: 0
    .deco-left
      position: absolute
      left: 2vw
      width: 5vw
      height: 75vh
      top: 2vh
      background: url("../assets/images/deco-left.svg")
      background-repeat: no-repeat
      // background-size: 100% auto
      background-size: contain
    .explore-icons
      position: absolute
      height: 15vh
      left: 2vw
      width: 5vw
      top: 80vh
      display: flex
      flex-direction: column
      align-items: flex-start
      justify-content: space-between
  .right
    position: absolute
    right: 0
    top: 0
    .explore-close-icon
      z-index: 999
    .deco-right
      position: absolute
      right: 2vh
      bottom: 2vh
      width: 5vw
      height: 90vh
      // top: 2vh
      background: url("../assets/images/deco-right.svg")
      background-repeat: no-repeat
      // background-size: 100%
      background-size: contain
      background-position-x: 0
    .fa-times
      position: absolute
      right: 3vh
      top: 2vh
      &:hover
        cursor: pointer

@media screen and (orientation: portrait)
  .explore-detail
    .warning
      display: initial
</style>
